
import { combineReducers } from 'redux';

import clientReducer from './client/client.reducer';
import messageReducer from './message/message.reducer';
import roomReducer from './room/room.reducer';
import operatorReducer from './operator/operator.reducer';
import loadingReducer from './loading/loading.reducer';
import tenantReducer from './tenant/tenant.reducer';

export default combineReducers({
    client: clientReducer,
    messages: messageReducer,
    room: roomReducer,
    operator: operatorReducer,
    loads: loadingReducer,
    tenant: tenantReducer
});